import ResourceList from '../components/ResourceList';
import React from "react";
import {toArray} from '../util/idMap';
import {LoadActiveStationsEpic} from '../actions/station.actions';
import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom'
import CircularProgress from 'material-ui/CircularProgress';
import DoneIcon from 'material-ui/svg-icons/action/done';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import {CardActions} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton'
import * as colors from 'material-ui/styles/colors';
import * as m from 'moment';
import ErrorBlock from '../components/ErrorBlock';

export class ActiveStationsList extends React.Component {

  componentDidMount() {
    this.props.loadActiveStations(this.props.companyId);
  }

  dateFormatter(data,colDef,rowData){
    return m(data).format('MM/DD/YYYY h:mm:ss a');
  }
  // location: {type: mongoose.Schema.Types.ObjectId, ref: 'Ready_Location'},
  // stationLastJoined: Date,
  // stationLastLeft: Date,
  // stationDisconnectReason: Number,
  // stationLastActivity: Date,
  // connected: Boolean
  getColumns = () => {
    return [
      {name: 'locationName', label: 'Location Name', width: 165},
      {name: 'softwareVersion', label: 'Version', width: 165},
      {name: 'connected', label: 'Connected', width: 40, render: (rowData) => rowData.connected? <DoneIcon color={colors.green500}/> : <ClearIcon color={colors.red500}/>},
      {name: 'stationLastJoined', label: 'Connected Date', width: 170, formatter: this.dateFormatter},
      {name: 'stationLastActivity', label: 'Last Ping', width: 170, formatter: this.dateFormatter},
      {name: 'stationLastLeft', label: 'Disconnected Date', width: 170, formatter: this.dateFormatter},
      {name: '_id', label: 'Station ID'}
    ]
  }

  render() {
    return (
      <div>
        <CardActions>
          <FlatButton label="Refresh" primary={true} onClick={()=>this.props.loadActiveStations(this.props.companyId)}/>
        </CardActions>
        <ResourceList columns={this.getColumns()} data={this.props.stations} showCheckboxes={false}/>
        {this.props.error? <ErrorBlock errorText="Unable to load station list from server at this time."/> : null}
        {this.props.loading? <div style={{textAlign: 'center'}}><CircularProgress/></div> : null }
      </div>
    );
  }
}

let mapStateToProps = ({stationsEndpoint, authEndpoint}, {match}) => ({
  stations: toArray(stationsEndpoint.stations),
  loading: stationsEndpoint.fetchInProgress,
  error: stationsEndpoint.fetchError,
  companyId: match.params.companyId || authEndpoint.company,
})

let mapDispatchToProps = (dispatch) => ({
  loadActiveStations : (companyId) => dispatch(LoadActiveStationsEpic(companyId))
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(ActiveStationsList));


// WEBPACK FOOTER //
// ./src/containers/ActiveStationsList.js